<template>
  <pro-list-frame
    ref="plTable"
    :title="($t('list') + ' ' + $t(type))"
    icon="mdi-cash-sync"
    :total="totalItems"
    :rows="items.length"
    :search.sync="search"
    :columns="toggleableHeaders"
    :hidden="hiddenColumns"
    :selected-count="selected.length"
    :loading="loading"
    :cell-sel="cellSel"
    :fixed="!mobileShow"
    :create-label="$t(type)"
    @refresh="getItems"
    @filter="filter = true"
    @print="printStudio = true"
    @create="goTo(type)"
    @toggle-column="toggleColumn"
    @show-all-columns="hiddenColumns = []"
    @cell-down="onCellDown"
    @cell-over="onCellOver"
    @clear-cells="clearCellSel"
    @clear-selection="selected = []"
  >
    <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <v-list-item
            v-show="type === 'removedPayments'"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            link
            @click="refreshRemovedItem"
          >
            <v-list-item-icon>
              <v-icon>mdi-delete-restore</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('refreshRemovedItem')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0 && type !== 'removedPayments'"
            :disabled="!selected || (selected && selected.length === 0) ? true : false"
            link
            @click="lockGroup('lock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('lock')" />
          </v-list-item>
          <v-list-item
            v-if="lockPermission && selected.length > 0 && type !== 'removedPayments'"
            link
            @click="unlockGroup('unlock')"
          >
            <v-list-item-icon>
              <v-icon>mdi-lock-open-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('unlock')" />
          </v-list-item>
          <v-list-item
            v-if="
              $store.state.permissions &&
              $store.state.permissions.includes('importExcelInvoice')
            "
            link
            @click="openUploadDialog"
          >
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="type"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
    </template>
    <template #kpis>
      <div class="pl-kpi pl-kpi--blue">
        <span class="pl-kpi__icon"><v-icon size="17">mdi-chart-bar</v-icon></span>
        <div class="pl-kpi__body">
          <span class="pl-kpi__label">{{ $t("totalSum") }}</span>
          <span class="pl-kpi__value pl-num">{{ faNum($numberFormat(summary ? summary.amount : 0)) }}</span>
        </div>
      </div>
    </template>
    <template #bulk>
      <button
        v-if="receiptKind"
        type="button"
        class="pl-bulk__btn"
        @click="receiptPrint()"
      >
        <v-icon size="17">mdi-printer-settings</v-icon>
        {{ $t("receiptGroupPrint") }}
      </button>
      <button
        v-if="type !== 'removedPayments'"
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
    </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-model="selected"
        v-column-resize="paymentsListColumnPlugins"
        v-column-drag="paymentsListColumnPlugins"
        v-column-pin="paymentsListColumnPlugins"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        multi-sort
        dense
        :show-select="showSelect"
        item-key="id"
        :hide-default-header="isMobile || mobileShow"
        :footer-props="plFooterProps"
      >
        <template v-if="isMobile" v-slot:item="{ item, index }">
          <tr>
            <td class="px-0">
              <v-list-item
                class="data-table-list-items px-0"
                :class="{
                  'mobile-td-list-border-red': item.type == 'pay' ? true : false,
                  'mobile-td-list-border-green': item.type == 'recieve' ? true : false,
                }"
                dense
              >
                <v-list-item-icon class="ps-2 me-1">
                  <div class="d-flex">
                    <p class="mt-3">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item
                          link
                          :disabled="item.lock ? true : false"
                          @click="edit(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-clipboard-edit</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/pay/cash/edit/' + item.id"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <log
                          :title-prop="$t('history')"
                          icon-prop="mdi-history"
                          :listProp="true"
                          :type-prop="typeForm"
                          :refIdProp="item.id"
                          mode-prop="button"
                        />
                        <v-list-item
                          v-show="removePermission(type)"
                          link
                          :disabled="item.lock ? true : false"
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.account ? item.account.name : "" }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("bank") }} : {{ item.bank ? item.bank.name : "" }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("document-number") }} :
                    {{ item.doc_header ? item.doc_header.number : "" }} | {{ $t("id") }} :
                    {{ item.id }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    {{ $t("date") }} : {{ item.date }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <v-chip
                      v-for="(relation, index) in item.relations"
                      :key="index"
                      :color="relation.color"
                      label
                      outlined
                      small
                      style="margin-left: 1px; margin-right: 1px"
                      class="px-1 mb-1"
                      @click="edit(item)"
                    >
                      {{ relation.name }}
                    </v-chip>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-show="item.remain && parseFloat(item.remain.remain) < 0"
                        small
                        color="blue"
                        outlined
                      >
                        {{ $t("creditor") }}
                      </v-chip>
                      <v-chip
                        v-show="item.remain && item.remain.remain > 0"
                        small
                        color="red"
                        outlined
                      >
                        {{ $t("debtor") }}
                      </v-chip>
                      <v-chip
                        v-show="item.remain && item.remain.remain == null"
                        small
                        color="green"
                        outlined
                      >
                        {{ $t("clearing") }}
                      </v-chip>
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="edit(item)">
                    {{ $numberFormat(item.amount) }} {{ item.currency.name }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="pl-action-cell">
            <v-menu v-if="type !== 'removedPayments'" offset-y>
              <template v-slot:activator="{ attrs, on }">
                <v-btn
                  color="primary"
                  class="pl-action-cell__btn"
                  v-bind="attrs"
                  icon
                  x-small
                  v-on="on"
                >
                  <v-icon small> mdi-dots-vertical </v-icon>
                </v-btn>
              </template>

              <v-list dense>
              <v-list-item link :disabled="item.lock ? true : false" @click="edit(item)">
                <v-list-item-icon>
                  <v-icon>mdi-clipboard-edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="lockPermission"
                link
                @click="lock(item, item.lock ? 'unlock' : 'lock')"
              >
                <v-list-item-icon>
                  <v-icon :color="item.lock ? 'green' : 'pink'">
                    {{ item.lock ? "mdi-lock-open-outline" : "mdi-lock-outline" }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="item.lock ? $t('unlock') : $t('lock')" />
              </v-list-item>
              <v-list-item v-if="item.doc_head_id" link @click="viewDocument(item)">
                <v-list-item-icon>
                  <v-icon>mdi-file-eye-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('viewAccountingDoc')" />
              </v-list-item>
              <v-list-item v-if="receiptKind" link @click="receiptPrint(item)">
                <v-list-item-icon>
                  <v-icon>mdi-receipt-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('treasuryReceiptPrint')" />
              </v-list-item>
              <v-list-item v-clipboard:copy="$baseURL + '/pay/cash/edit/' + item.id" link>
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission(type)"
                link
                :disabled="item.lock ? true : false"
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
              </v-list>
            </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                {{ item.user.firstname }} {{ item.user.lastname }}
              </div>
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.doc_header.number="{ item }">
          <a
            v-if="item.doc_header"
            @click="openComponent('accountingPrint', item.doc_head_id)"
          >
            {{ item.doc_header.number }}
          </a>
        </template>
        <template v-slot:item.account.name="{ item }">
          <div class="d-flex">
            <a
              style="padding-top: 6px"
              class="me-2"
              @click="openComponent('account', item.account_id)"
            >
              {{ item.account ? item.account.name : $t("haveNot") }}
            </a>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  icon
                  small
                  v-on="on"
                  @click="openComponent('accountingTurnover', item.account.fin_id)"
                >
                  <v-icon color="teal" style="font-size: 22px">
                    mdi-playlist-check
                  </v-icon>
                </v-btn>
              </template>
              <span>{{ $t("turnover") }}</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:item.bank.name="{ item }">
          <a @click="openComponent('accountingTurnover', item.bank.fin_id)">
            {{ item.bank.name }}
          </a>
        </template>
        <template v-slot:item.amount="{ item }">
          {{ $numberFormat(item.amount) }} {{ item.currency.name }}
        </template>
        <template v-slot:item.branch.name="{ item }">
          {{ item.branch ? item.branch.name : "ندارد" }}
        </template>
        <template v-slot:item.issue_tracking="{ item }">
          {{ item.issue_tracking ? item.issue_tracking : "ندارد" }}
        </template>
        <template v-slot:item.title="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                :color="item.last_status.status.color"
                text
                v-on="on"
                @click="edit(item)"
              >
                {{ item.title }}
              </v-btn>
            </template>
            <span>{{ $t("edit") }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
          <v-icon v-if="item.lock" color="red" style="font-size: 22px">
            mdi-lock-outline
          </v-icon>
          <v-chip
            v-if="type === 'removedPayments'"
            :color="item.type === 'pay' ? 'blue' : 'green'"
            label
            small
            style="margin-left: 1px; margin-right: 1px"
            class="px-1 mb-1"
          >
            <span class="px-1 white--text">
              {{ $t(item.type) }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.relations="{ item }">
          <div class="pt-1" v-if="item.relations">
            <v-chip
              v-for="(relation, index) in item.relations"
              :key="index"
              :color="relation.color"
              label
              outlined
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="edit(item)"
            >
              {{ relation.name }}
            </v-chip>
          </div>
          <v-card-text v-else class="pa-0 text-caption text-disable">ندارد</v-card-text>
        </template>
        <template v-slot:item.time="{ item }">
          {{ item.time }}
        </template>
        <template v-slot:body.append>
          <tr v-if="isMobile || mobileShow">
            <td :colspan="`${isMobile ? 6 : Number(showHeaders.length)}`">
              <div style="width: 100%" class="pa-1">
                <strong>{{ $t("sumInPage") }}</strong
                >:
                <v-chip color="primary" class="px-1">
                  <span class="px-1 white--text">
                    {{ $numberFormat(totals.amount) }}
                  </span>
                </v-chip>
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sumInPage") }}</span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.amount) }}
                {{ $store.state.currency.name }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="($t('list') + ' ' + $t(type))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />
  </pro-list-frame>
</template>

<script>
export default {
  name: "PaymentsListDesktopView",
};
</script>
